import { render, staticRenderFns } from "./cosDocPay.vue?vue&type=template&id=61c112ad&scoped=true"
import script from "./cosDocPay.vue?vue&type=script&lang=js"
export * from "./cosDocPay.vue?vue&type=script&lang=js"
import style0 from "./cosDocPay.vue?vue&type=style&index=0&id=61c112ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c112ad",
  null
  
)

export default component.exports